module.exports = __webpack_public_path__ + "3485e96a61948e51d15ff89fe061ddd1.woff";